var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudArrowUpSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 9.82422V15.8242M12.0005 9.82422L10.0005 11.8242M12.0005 9.82422L14.0005 11.8242M8.40049 19.3242C5.41815 19.3242 3.00049 16.9286 3.00049 13.9735C3.00049 11.5243 4.80049 9.26172 7.50049 8.82422C8.34743 6.81059 10.3519 5.32422 12.6898 5.32422C15.6845 5.32422 18.1322 7.64673 18.3005 10.5742C19.8898 11.2691 21.0005 12.9745 21.0005 14.8211C21.0005 17.3081 18.9858 19.3242 16.5005 19.3242H8.40049Z",
    stroke: "#5D2EDE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudArrowUpSvgrepoCom1);
export default __webpack_public_path__ + "static/media/cloud-arrow-up-svgrepo-com 1.d7a13f09b8a91c4ad0a50a32c47b8f9f.svg";
export { ForwardRef as ReactComponent };